// extracted by mini-css-extract-plugin
module.exports = {"container":"CountryCode_container__dsYpw","flag":"CountryCode_flag__ThfPv","dialCode":"CountryCode_dialCode__fzs2o","name":"CountryCode_name__gL0dT"};